export enum RolloverMeasuringType {

    Pips = 1,
    Percentage = 2,
    Fixed = 3,
}
